import * as S from '@effect/schema/Schema';
import { Image } from '@infl-ts/util-fetch-challenge-list';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { Leaderboard } from '../leaderboard/codecs';
var Channel = t.type({
  id: t.string,
  name: t.string,
  banner: nullable(Image),
  description: nullable(t.string),
  leaderboard: nullable(Leaderboard)
});
export var ChannelOutput = t.type({
  channel: nullable(Channel),
  profile: t.type({
    id: t.string,
    isAdmin: t["boolean"],
    showOnLeaderBoard: t["boolean"]
  })
});
export var ChannelPageBlockConfig = S.struct({
  typename: S.literal('ChannelPageBlock'),
  id: S.string,
  hash: S.string
});